/* eslint-disable react-hooks/exhaustive-deps */

import './header.css'

import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router';
import Icons from '../icons/Icons';
import {
    AppBar,
} from "@progress/kendo-react-layout";
import { HeaderAlerts } from './HeaderAlerts';
import parse from 'html-react-parser';
import { CopyToClipboard } from '../CopyToClipboard';
import { isNullOrEmpty } from '../../helpers/ObjectHelpers';
import { isLoggedIn } from '../../helpers/AuthHelpers';
import { useImpersonateClassName } from '../../hooks/useImpersonateClassName';
import { useHeaderContent } from '../../hooks/useAppStore';

export default function Header({ burgerButtonClick }) {
    
    const navigate = useNavigate();
    const impersonateClassName = useImpersonateClassName();

    const [headerData, setHeaderData] = useState({
        title: "",
        subTitle: "",
        canGoBack: true,
        canCopyTitle: false,
        canCopySubTitle: false
    });
    const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);

    const headerInterval = React.useRef(null);
    const noBackButton = !headerData.canGoBack;
    const noHeaderTitle = isNullOrEmpty(headerData.title);

    const headerContent = useHeaderContent();

    useEffect(() => {
        if (!headerContent) return;
        setHeaderData(headerContent);
    }, [headerContent]);

    useEffect(() => {
        initializeAlertsAsync();
        headerInterval.current = setInterval(() => initializeAlertsAsync(), 30000);// Check for alerts every 30 seconds

        return () => {
            if (!headerInterval.current) {
                clearInterval(headerInterval.current);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        isUserLoggedIn &&
        <>
            <AppBar 
            id="AppBar" 
            className={`app-bar${noBackButton ? " no-back" : ""}${noHeaderTitle ? " no-title" : ""} ${impersonateClassName}`}
            positionMode="static">
                 { (headerData.canGoBack) &&   
                <div className="column-1">              
                    <button
                        className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-base"
                        onClick={handleOnBackClick}>
                        <Icons iconName="back" />                
                    </button>                 
                </div>
                }
                <div className="column-1-2">
                    <div>
                        <NavLink to="/" className="nav-link">
                            Njord<b>Pilot</b>Web
                        </NavLink>
                    </div>
                </div>
                <div className="column-3">
                    <div className="header text-truncate">
                        {
                            (!isNullOrEmpty(headerData.title)) &&
                                headerData.canCopyTitle ?
                                <CopyToClipboard title={headerData.title} text={headerData.title} />
                                : parse(headerData.title)
                        }
                    </div>
                    <div className="b text-truncate">
                        {
                            (!isNullOrEmpty(headerData.subTitle)) &&
                                headerData.canCopySubTitle ?
                                <CopyToClipboard title={headerData.subTitle} text={headerData.subTitle} />
                                : parse(headerData.subTitle)
                        }
                    </div>
                </div>
                <div className="column-4">
                    <HeaderAlerts/>
                {/*    <div className="app-bar-search">*/}
                {/*        {*/}
                {/*            isLoggedIn && */}
                {/*                <HeaderAppBarSearch/>*/}
                {/*        }*/}
                {/*    </div>*/}
                </div>
                <div className="column-5">
                    <button
                        className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-base"
                        onClick={handleBurgerButtonClick}>
                        <Icons iconName="hamburger" />
                    </button>
                </div>
            </AppBar>
        </>
    );
    
    async function initializeAlertsAsync() {
        setIsUserLoggedIn(isLoggedIn());
    }
    
    function handleOnBackClick() {
        navigate(-1);
    }

    function handleBurgerButtonClick() {
        burgerButtonClick();
    }
}

